import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {AnimationHandler} from 'components/customer/Preview3D/animation/entity/AnimationHandler';
import {Dimension} from '../types';

export const toggleCornerDrawerHandler = ({
    mesh,
    insert,
    index,
}: {
    mesh: THREE.Group<THREE.Object3DEventMap> | THREE.Mesh;
    isLeftDrawer?: boolean;
    isRightDrawer?: boolean;
    insert: Dimension;
    index: number;
}): AnimationHandler => {
    const initialPosition = {y: insert.y, x: insert.x};

    const offset = index * 75 + 100;

    const openPosition = {y: insert.y - offset, x: insert.x + offset};
    const closePosition = {y: insert.y, x: insert.x};

    const openDrawer = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const openTween = new TWEEN.Tween(
                initialPosition,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(openPosition, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    mesh.position.x = initialPosition.x;
                    mesh.position.y = initialPosition.y;
                });

            openTween.start();
        });

    const closeTween = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const tween = new TWEEN.Tween(
                initialPosition,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(closePosition, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    mesh.position.x = initialPosition.x;
                    mesh.position.y = initialPosition.y;
                });

            tween.start();
        });

    return {
        open: [openDrawer],
        close: [closeTween],
    };
};
